// Price
export const PENCE_IN_POUND = 100
export const MIN_CARD_PAYMENT = 30

// Time
export const MSEC_IN_SEC = 1000,
    SEC_IN_MIN = 60,
    MIN_IN_HOUR = 60
export const MSEC_IN_HOUR = MSEC_IN_SEC * SEC_IN_MIN * MIN_IN_HOUR
export const MSEC_IN_MIN = MSEC_IN_SEC * SEC_IN_MIN
